<script>
import AdminLayout from '@layouts/admin-main'
import PgTransactionList from '@components/admin/pg-transaction-list'

export default {
  page: {
    title: 'Admin::PgTransactionList',
    meta: [{ name: 'description', content: 'Admin::PgTransactionList' }],
  },
  components: { AdminLayout, PgTransactionList },
}
</script>

<template>
  <AdminLayout>
    <PgTransactionList></PgTransactionList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
